// core
import Imgix from './core/Imgix'
import {ixPolyfill} from './core/Imgix'
import Waypoints from './core/Waypoints'
import LightboxGallery from './core/LightboxGallery'
import ButtonModal from './core/ButtonModal'

// vitals
import SiteVitals from './modules/SiteVitals'
import PrimaryNavigation from './modules/PrimaryNavigation'

// modules
import Accordion from './modules/Accordion'
import Grid from './modules/Grid'
import ReadMore from './modules/ReadMore'
import Slider from './modules/Slider'
import ImageParallax from './modules/ImageParallax'; // ! to be updated with child-app image simpleParallax
import GravityFormsValidator from './modules/GravityFormsValidator'
import SplitHeadings from './modules/SplitHeadings'
import TabbedList from './modules/TabbedList'
import FilterableAccordion from './modules/FilterableAccordion'
import AnimatedHero from './modules/AnimatedHero'
import WrapHeadingText from './modules/WrapHeadingText'
import DropAHint from './core/DropAHint'
import QuicklinksOverflow from './modules/QuicklinksOverflow'

// core
new DropAHint();
new Imgix();
new Waypoints();
new LightboxGallery();
new ButtonModal();

// imgix polyfill for core
ixPolyfill();

// vitals
new SiteVitals()

// modules
new PrimaryNavigation()

document.querySelectorAll('.c-animated-hero').forEach(element => {
    new AnimatedHero(element);
})

document.querySelectorAll('.c-cta--lede, .c-cta--split-heading').forEach(element => {
    new ReadMore(element);
});

document.querySelectorAll('.c-quicklinks').forEach(element => {
    new QuicklinksOverflow(element);
});

document.querySelectorAll("[data-module=grid]").forEach((element) => {
    new Grid(element)
})

document.querySelectorAll("[data-module=slider]").forEach((element) => {
    new Slider(element)
})

document.querySelectorAll('.c-form').forEach(element => {
    new GravityFormsValidator({element: element});
});

document.querySelectorAll("[data-module=tabbed-component]").forEach(element => {
    new TabbedList(element);
})

document.querySelectorAll(".c-filterable-accordion").forEach((element) => {
    new FilterableAccordion(element)
});

// wrap promoted centred image heading's __heading content with span
document.querySelectorAll('.c-cta--promoted-centred-image').forEach(element => {
    new WrapHeadingText(element, '.c-cta__heading')
});

// programatically set accordions to allow for multiple contents to be shown
document.querySelectorAll("[data-module=accordion]").forEach((element) => {
    let collapseOtherItems = false;

    const classList = element.parentElement.classList;

    switch (true) {
        case classList.contains('c-accordion--faqs'):
            collapseOtherItems = true;
            break;
        default:
            collapseOtherItems = false;
            break;
    }

    new Accordion(element, collapseOtherItems)
})

document.addEventListener("DOMContentLoaded", () => {

    // ! Images to be defined
    /* default options:
        orientation: 'up',      // 'up', 'down', 'left', 'right', or 'default'
        scale: 1.2,             // Scale factor (1 = no scaling)
        overflow: false,        // Whether to allow overflow (true/false)
        delay: 0.4,             // Transition delay (in seconds)
        transition: 'cubic-bezier(0,0,0,1)', // CSS transition timing function
        maxTransition: 200,       // Limit the parallax effect in pixels (0 = no limit)
        customContainer: null,  // Custom container (if needed)
        customWrapper: null,    // Custom wrapper (if needed)
        breakpoint: false       // Disable parallax below a certain width (false or number)
    */
    new ImageParallax([
        '.c-cta--promoted-centred-image .o-media-container__media',
        '.c-cta__media-container:not(.o-slider):not(.o-media-container--list) img',
        '.c-cta__media-container:not(.o-slider):not(.o-media-container--list) video', // testing video responsivity
        [
            '.c-page-prefooter__background',
            {
                scale: 1.3,
                orientation: 'down',
                delay: 0.6
            }
        ]
    ]);

    // Used to wrap split headings allowing for wrap detection
    const splitHeadingsElements = document.querySelectorAll('.c-cta--split-heading .c-cta__heading-group, .c-heading-group .c-heading-group__heading');
    new SplitHeadings(splitHeadingsElements);

    window.dispatchEvent(new Event('resize'));
    window.dispatchEvent(new Event('optimisedScroll'));
});

// Prevent esbuild from using either of jQuery or underscore global function names
// as these are both used externally
_ = _.noConflict();
$ = $.noConflict();